<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import '../../../design/app.scss';

function dateToISOLikeButLocal(date) {
    const offsetMs = date.getTimezoneOffset() * 60 * 1000;
    const msLocal =  date.getTime() - offsetMs;
    const dateLocal = new Date(msLocal);
    const iso = dateLocal.toISOString();
    const isoLocal = iso.slice(0, 19);
    return isoLocal;
}

/**
 * Releases Component
 */
export default {
  page: {
    title: "Releases",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data () {
    return {
      title: "Releases",
      type: 'fcfs',
      stock: '0',
      startDate: '2021-06-06T13:45:00',
      endDate: '2021-06-07T13:45:00',
      error: false,
      errorMessage: '',
      success: false,
      submitting: false
    };
  },
  methods: {
    save (e) {
      e.preventDefault()
      
      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false

      const { type, stock, startDate, endDate } = this

      if (!type || type.trim() == '') {
        this.error = true
        this.errorMessage = 'All fields are required!'
      }

      if (type == 'fcfs' && (!stock || stock.trim() == '' || Number(stock) < 0)) {
        this.error = true

        if (Number(stock) < 0) {
          this.errorMessage = 'Stock must be greater than or equal to 0!'
        } else {
          this.errorMessage = 'All fields are required!'
        } 
      }

      if (!startDate || startDate.trim() == '') {
        this.error = true
        this.errorMessage = 'All fields are required!'
      }

      if (type == 'raffle' && (!endDate || endDate.trim() == '' || (new Date(startDate)).getTime() > (new Date(endDate)).getTime())) {
        this.error = true

        if ((new Date(startDate)).getTime() > (new Date(endDate)).getTime()) {
          this.errorMessage = 'End date must be later than start date!'
        } else {
          this.errorMessage = 'All fields are required!'
        } 
      }

      if (!this.error) {
        this.submitting = true

        fetch(`/api/v1/release/save`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ type, stock: Number(stock), startDate, endDate }),
          credentials: 'include'
        }).then(res => {
          this.submitting = false

          if (res.status == 200) {
            this.success = true
          } else if (res.status == 400) {
            this.errorMessage = 'All fields are required!'
            this.error = true
          } else {
            this.errorMessage = 'An unexpected error occurred, please try again later'
            this.error = true
          }
        }).catch(() => {
          this.submitting = false
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        })
      }
    },
    pullStock (e) {
      e.preventDefault()
      
      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false

      this.submitting = true

      fetch(`/api/v1/release/pullStock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      }).then(res => {
        this.submitting = false

        if (res.status == 200) {
          this.success = true
          this.stock = '0'
          this.title = `Releases (Current stock: 0)`
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
        })
    },
    fetchData () {
      fetch(`/api/v1/release/get`, {
        credentials: 'include'
      }).then(res => res.json()).then(res => {
        this.stock = res.stock
        this.type = res.type
        let startDate = new Date(res.startDate)
        this.startDate = dateToISOLikeButLocal(startDate)
        this.endDate = (new Date(res.endDate)).toISOString().slice(0, -8)
      }).catch(err => {
        console.log(err)
      })
    },
    updateStockInfo () {
      fetch(`/api/v1/release/get`, {
        credentials: 'include'
      }).then(res => res.json()).then(res => {
        if (!res || !res.stock) {
          res = { stock: 'N/A' }
        }

        this.title = `Releases (Current stock: ${res.stock})`
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.fetchData()
    setInterval(this.updateStockInfo, 1000)
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b-alert v-model="error" class="mb-4" variant="danger" dismissible>{{ errorMessage }}</b-alert>
                <b-alert v-model="success" class="mb-4" variant="success" dismissible>Release has been successfully saved!</b-alert>

                <form class="form-horizontal" role="form" @submit.prevent="save">
                  <div class="mb-3 row">
                    <label class="col-md-2 col-form-label">Type</label>
                    <div class="col-md-10">
                      <select class="form-control" v-model="type">
                        <option value="fcfs">FCFS</option>
                        <option value="raffle">Raffle</option>
                      </select>
                    </div>
                  </div>

                  <b-form-group
                    class="mb-3"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Stock"
                    label-for="stock"
                    v-if="type == 'fcfs'"
                  >
                    <b-form-input
                      id="stock"
                      type="number"
                      name="stock"
                      v-model="stock"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Start date"
                    label-for="start-date"
                  >
                    <b-form-input
                      id="start-date"
                      v-model="startDate"
                      type="datetime-local"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="End date"
                    label-for="end-date"
                    v-if="type == 'raffle'"
                  >
                    <b-form-input
                      id="end-date"
                      v-model="endDate"
                      type="datetime"
                    ></b-form-input>
                  </b-form-group>

                  <div class="col-sm-auto" style="text-align:right">
                    <b-button variant="danger" class="w-md" v-on:click="pullStock">Pull stock</b-button>
                    <b-button variant="primary" class="w-md" v-on:click="save">Save</b-button>
                  </div>
                </form>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
  
</template>
